// extracted by mini-css-extract-plugin
module.exports = {"text":"ModuleTile_text_1xiha"};